import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import useNavigationState from '../use-navigation-state';

const useNavigateToNextStep = () => {
  const navigate = useNavigate();
  const navigationState = useNavigationState();
  const callback = useCallback(() => {
    navigate('/', { state: navigationState });
  }, [navigate, navigationState]);

  return callback;
};

export default useNavigateToNextStep;
